<template>
  <ul class="nav flex-column">
    <li class="nav-item">
      <Link class="nav-link" href="/" :class="isUrl('') ? 'active' : ''">
        <icon name="dashboard" class="" width="20" height="20" />
        <span>Dashboard</span>
      </Link>
    </li>

    <li class="nav-item" v-if="auth.user.role_admin || auth.user.role_main_agent">
      <Link class="nav-link" href="/bookings" :class="isUrl('bookings') ? 'active' : ''">
        <icon name="booking" class="" width="20" height="20" />
        <span>Bookings</span>
      </Link>
    </li>

    <li class="nav-item" v-if="!(auth.user.role_admin || auth.user.role_main_agent)">
      <Link class="nav-link" href="/agent-bookings" :class="isUrl('agent-bookings') ? 'active' : ''">
        <icon name="booking" class="" width="20" height="20" />
        <span>Bookings</span>
      </Link>
    </li>

    <li class="nav-item">
      <Link class="nav-link" href="/customers" :class="isUrl('customers') ? 'active' : ''">
        <icon name="customers" class="" width="20" height="20" />
        <span>Customers</span>
      </Link>
    </li>

    <li class="nav-item dropdown" v-if="auth.user.role_agency">
      <Link class="nav-link" :href="`/agencies/${auth.user.agency.id}/view`" :class="isUrl('agencies') ? 'active' : ''">
        <icon name="agency" class="" width="20" height="20" />
        <span>Agency</span>
      </Link>
    </li>


    <li class="nav-item dropdown" v-if="auth.user.role_admin || auth.user.role_main_agent">
      <Link class="nav-link" href="/agencies" :class="isUrl('agencies') ? 'active' : ''">
        <icon name="agency" class="" width="20" height="20" />
        <span>Agencies</span>
      </Link>

      <ul class="dropdown-menu" :class="[isUrl('agencies') ? 'show' : '', isUrl('users') ? 'show' : '']">
        <li>
          <Link class="dropdown-item" href="/users" :class="isUrl('users') ? 'active' : ''">Agents</Link>
        </li>
      </ul>
    </li>

    <li class="nav-item dropdown" v-if="auth.user.role_admin">
      <Link class="nav-link" href="/settings" :class="isUrl('settings') ? 'active' : ''">
        <icon name="plane" class="" width="20" height="20" />
        <span>Settings</span>
      </Link>

      <ul class="dropdown-menu" :class="isUrl('settings') ? 'show' : ''">
        <li>
          <Link class="dropdown-item" href="/settings/operators" :class="isUrl('settings/operators') ? 'active' : ''">Operators</Link>
        </li>
        <li>
          <Link class="dropdown-item" href="/settings/types" :class="isUrl('settings/types') ? 'active' : ''">Types / Class</Link>
        </li>
        <li>
          <Link class="dropdown-item" href="/settings/airports" :class="isUrl('settings/airports') ? 'active' : ''">Airports</Link>
        </li>
        <li>
          <Link class="dropdown-item" href="/settings/products" :class="isUrl('settings/products') ? 'active' : ''">Products</Link>
        </li>

        <li>
          <Link class="dropdown-item" href="/settings/mail" :class="isUrl('settings/mail') ? 'active' : ''">Mail Settings</Link>

          <ul class="dropdown-menu" :class="isUrl('settings/mail') ? 'show' : ''">
            <li>
              <Link class="dropdown-item" href="/settings/mail/templates" :class="isUrl('settings/mail/templates') ? 'active' : ''">Mail Templates</Link>
            </li>
            <li>
              <Link class="dropdown-item" href="/settings/mail/inserts" :class="isUrl('settings/mail/inserts') ? 'active' : ''">Mail Inserts</Link>
            </li>
            <li>
              <Link class="dropdown-item" href="/settings/mail/pdfs" :class="isUrl('settings/mail/pdfs') ? 'active' : ''">Mail PDFs</Link>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
  position: static;
  border-radius: 0;
  background: var(--bs-gray-700);

  .dropdown-item {
    color: var(--bs-gray-100);
  }

  .dropdown-menu {
    padding-left: 0.5rem;
  }
}
.dropdown-item:hover, .dropdown-item:focus {
  background: $gray-600;
}
</style>
